import { addDays } from 'date-fns/addDays';

/**
 * UI-agnostic calendar time primitives.
 *
 * These are pure date/number utilities shared by any calendar presentation
 * layer. They carry no rendering, layout or pixel semantics — only the
 * underlying temporal math that must stay stable across UI redesigns.
 */

/** Returns `count` consecutive days starting at `start` (inclusive). */
export function makeDays(start: Date, count: number): Date[] {
  return Array.from({ length: count }, (_, index) => addDays(start, index));
}

/** Minutes elapsed since the local start of `value`'s day (0..1439). */
export function minutesSinceStartOfDay(value: Date): number {
  return value.getHours() * 60 + value.getMinutes();
}

/**
 * Whole minutes between `start` and `end`, rounded to nearest minute and
 * clamped at 0 (never negative).
 */
export function minutesBetween(start: Date, end: Date): number {
  return Math.max(0, Math.round((end.getTime() - start.getTime()) / 60000));
}
